// extracted by mini-css-extract-plugin
module.exports = {"ToastModal":"Toast_ToastModal__1SY89","Open":"Toast_Open__3o3Br","Close":"Toast_Close__29NXZ","Icon":"Toast_Icon__3vqtG"};